import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { stackApp } from './stackApp';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (stackApp) {
  const { StackProvider } = require('@stackframe/react');
  root.render(
    <React.StrictMode>
      <StackProvider app={stackApp}>
        <App />
      </StackProvider>
    </React.StrictMode>
  );
} else {
  // No auth credentials — run as guest-only
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
